export default "__VITE_ASSET__5zus$XXB__"